import type { ReactNode, JSX } from 'react';
import { type VariantProps, tv } from 'tailwind-variants';

import type { CommonProps } from '../../types';
import { CloseIcon } from '@beat-venues/ui/subset';
import { FormInputGroup } from '../../molecules';

export interface FormCheckboxProps
    extends CommonProps,
        VariantProps<typeof FormCheckboxStyles> {
    children?: ReactNode;
    label?: string | null;
    id: string;
    value?: string;
    defaultChecked?: boolean;
    isDisabled?: boolean;
    wrapperClassName?: string;
    checked?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FormCheckboxStyles = tv({
    slots: {
        input: 'sr-only peer',
        label: 'flex gap-3 hover:cursor-pointer group',
        checkbox:
            'relative bg-gray-500 mt-1 shrink-0 text-center w-4 h-4 inline-block text-gray-500 peer-checked:group-[]:bg-white rounded-sm relative peer-focus-visible:group-[]:ring-offset-brand-700 peer-focus-visible:group-[]:outline-none peer-focus-visible:group-[]:ring-1 peer-focus-visible:group-[]:ring-offset-2 peer-focus-visible:group-[]:ring-white',
        times: 'absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 hidden peer-checked:group-[]:group-[]:block',
    },
});

export const FormCheckbox = ({
    className,
    children,
    label,
    id,
    value,
    isDisabled,
    defaultChecked,
    wrapperClassName,
    checked,
    testId = 'form-checkbox',
    onChange,
}: FormCheckboxProps): JSX.Element => {
    const { input, label: labelStyles, checkbox, times } = FormCheckboxStyles();
    return (
        <FormInputGroup className={wrapperClassName} errorClassName="ml-7">
            <input
                data-testid={testId}
                className={input({ className })}
                checked={checked}
                defaultChecked={defaultChecked}
                id={id}
                type="checkbox"
                value={value ?? id}
                onChange={onChange}
                disabled={isDisabled}
            />
            <label className={labelStyles()} htmlFor={id}>
                {children ?? (
                    <>
                        <span className={checkbox()}>
                            <CloseIcon className={times()} size="xs" />
                        </span>
                        {label}
                    </>
                )}
            </label>
        </FormInputGroup>
    );
};
